var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoMain(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "5526 549 1435 468",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{clip-path:url(#b);}.b{fill:#de617a;font-size:150px;font-family:Lato-Bold, Lato;font-weight:700;}.c{fill:#000;}.d{font-size:100px;font-family:JustAnotherHand-Regular, Just Another Hand;letter-spacing:0.1em;font-weight:400;}.e,.i,.j,.l,.o{fill:none;}.e,.f,.g,.h,.i{stroke:#000;}.e,.g{stroke-width:6px;}.f{stroke-width:2px;}.g,.h,.n{fill:#fff;}.h,.i{stroke-width:4px;}.k,.m,.n,.p{stroke:none;}.o{clip-path:url(#d);}.p{fill:#000;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 5526,
    y: 549,
    width: 1435,
    height: 468
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "d"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a",
    className: "a"
  }, /*#__PURE__*/React.createElement("text", {
    className: "b",
    transform: "translate(5846 534)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "c"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 15.438,
    y: 148
  }, "AnnaLiz "), /*#__PURE__*/React.createElement("tspan", {
    x: 38.05,
    y: 293
  }, "Hair Salon ")), /*#__PURE__*/React.createElement("tspan", {
    className: "d"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 310.564,
    y: 438
  }, "styled with style"))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(5526 549)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(6 0.031)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M248.149,2443.959s153.028-28,203.852-55.065c23.252-12.38,10.057-35.017-26.558-35.692-75.212-1.39-177.756,48.321-228.389,50.049-22.488.767-40.206-12.6-35.694-41.108,3.562-19.466,16.772-24.782,29.629-30.385,27.064-11.8,28.8-20.58,28.8-20.58",
    transform: "translate(-160.654 -2129.076)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "f",
    transform: "matrix(0.799, -0.602, 0.602, 0.799, 55.362, 163.926)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "k",
    width: 272.385,
    height: 22.594,
    rx: 11.297
  }), /*#__PURE__*/React.createElement("rect", {
    className: "l",
    x: 1,
    y: 1,
    width: 270.385,
    height: 20.594,
    rx: 10.297
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(66.117 171.947)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M 261.0882263183594 21.59419822692871 L 11.29710674285889 21.59419822692871 C 5.61924934387207 21.59419822692871 0.9999993443489075 16.97494888305664 0.9999993443489075 11.29709148406982 C 0.9999993443489075 5.619234561920166 5.61924934387207 0.9999843239784241 11.29710674285889 0.9999843239784241 L 261.0882263183594 0.9999843239784241 C 266.7660217285156 0.9999843239784241 271.3852844238281 5.619234561920166 271.3852844238281 11.29709148406982 C 271.3852844238281 16.97494888305664 266.7660217285156 21.59419822692871 261.0882263183594 21.59419822692871 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M 261.0882263183594 20.59419822692871 C 266.2146301269531 20.59419822692871 270.3852844238281 16.42351913452148 270.3852844238281 11.29709148406982 C 270.3852844238281 6.170662879943848 266.2146301269531 1.999984383583069 261.0882263183594 1.999984383583069 L 11.29710674285889 1.999984383583069 C 6.17067813873291 1.999984383583069 1.999999403953552 6.170662879943848 1.999999403953552 11.29709148406982 C 1.999999403953552 16.42351913452148 6.17067813873291 20.59419822692871 11.29710674285889 20.59419822692871 L 261.0882263183594 20.59419822692871 M 261.0882263183594 22.59419822692871 L 11.29710674285889 22.59419822692871 C 5.057892322540283 22.59419822692871 -6.4522873799433e-07 17.53630638122559 -6.4522873799433e-07 11.29709148406982 C -6.4522873799433e-07 5.057877063751221 5.057892322540283 -1.565878665132914e-05 11.29710674285889 -1.565878665132914e-05 L 261.0882263183594 -1.565878665132914e-05 C 267.3273620605469 -1.565878665132914e-05 272.3852844238281 5.057877063751221 272.3852844238281 11.29709148406982 C 272.3852844238281 17.53630638122559 267.3273620605469 22.59419822692871 261.0882263183594 22.59419822692871 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(55.447 153.119)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M 21 40 C 15.92492008209229 40 11.15359973907471 38.02365875244141 7.564970016479492 34.43503189086914 C 3.976340055465698 30.84639930725098 2 26.07508087158203 2 21 C 2 15.92492008209229 3.976340055465698 11.15359973907471 7.564970016479492 7.564970016479492 C 11.15359973907471 3.976340055465698 15.92492008209229 2 21 2 C 26.07508087158203 2 30.84639930725098 3.976340055465698 34.43503189086914 7.564970016479492 C 38.02365875244141 11.15359973907471 40 15.92492008209229 40 21 C 40 26.07508087158203 38.02365875244141 30.84639930725098 34.43503189086914 34.43503189086914 C 30.84639930725098 38.02365875244141 26.07508087158203 40 21 40 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M 21 38 C 25.54085922241211 38 29.80994033813477 36.231689453125 33.02082061767578 33.02082061767578 C 36.231689453125 29.80994033813477 38 25.54085922241211 38 21 C 38 16.45914077758789 36.231689453125 12.19005966186523 33.02082061767578 8.979180335998535 C 29.80994033813477 5.768310070037842 25.54085922241211 4 21 4 C 16.45914077758789 4 12.19005966186523 5.768310070037842 8.979180335998535 8.979180335998535 C 5.768310070037842 12.19005966186523 4 16.45914077758789 4 21 C 4 25.54085922241211 5.768310070037842 29.80994033813477 8.979180335998535 33.02082061767578 C 12.19005966186523 36.231689453125 16.45914077758789 38 21 38 M 21 42 C 9.402020454406738 42 0 32.59798049926758 0 21 C 0 9.402020454406738 9.402020454406738 0 21 0 C 32.59798049926758 0 42 9.402020454406738 42 21 C 42 32.59798049926758 32.59798049926758 42 21 42 Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "g",
    transform: "matrix(0.174, 0.985, -0.985, 0.174, 62.903, 295.087)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "c",
    className: "k",
    width: 50.209,
    height: 4.51,
    rx: 2.255
  }), /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M0,1.510467529296875h50.20928955078125M47.20928955078125,0v4.510467529296875M50.20928955078125,3h-50.20928955078125M3,4.510467529296875v-4.510467529296875"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.985, -0.174, 0.174, 0.985, 40.868, 314.115)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "h",
    transform: "translate(0.174 -0.985)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "k",
    width: 23.849,
    height: 4.51,
    rx: 2.255
  }), /*#__PURE__*/React.createElement("rect", {
    className: "l",
    x: 2,
    y: 2,
    width: 19.849,
    height: 0.51,
    rx: 0.255
  })), /*#__PURE__*/React.createElement("g", {
    className: "h",
    transform: "translate(-0.811 14.532)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "k",
    width: 23.849,
    height: 4.51,
    rx: 2.255
  }), /*#__PURE__*/React.createElement("rect", {
    className: "l",
    x: 2,
    y: 2,
    width: 19.849,
    height: 0.51,
    rx: 0.255
  }))), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M33.824,165.91c8.753-1.036,10.927-2.651,15.795-.941,5.322,1.867,8.718,7.558,9.291,10.633a16.2,16.2,0,0,1-2.477,12.285c-3.143,4.434-7.293,3.716-17.963,5.781",
    transform: "translate(29.28 139.304)"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "j",
    transform: "translate(214.615 161.418)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M11.838,0h98.344a11.838,11.838,0,1,1,0,23.675H11.838A11.838,11.838,0,0,1,11.838,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M 110.1817932128906 19.67543411254883 C 114.503532409668 19.67543411254883 118.0195159912109 16.15945243835449 118.0195159912109 11.83771324157715 C 118.0195159912109 7.515973091125488 114.503532409668 3.999993324279785 110.1817932128906 3.999993324279785 L 11.83771419525146 3.999993324279785 C 7.515974044799805 3.999993324279785 3.999994277954102 7.515973091125488 3.999994277954102 11.83771324157715 C 3.999994277954102 16.15945243835449 7.515974044799805 19.67543411254883 11.83771419525146 19.67543411254883 L 110.1817932128906 19.67543411254883 M 110.1817932128906 23.67543411254883 L 11.83771419525146 23.67543411254883 C 5.299934387207031 23.67543411254883 -5.819091711600777e-06 18.3754940032959 -5.819091711600777e-06 11.83771324157715 C -5.819091711600777e-06 5.299933433532715 5.299934387207031 -6.758422841812717e-06 11.83771419525146 -6.758422841812717e-06 L 110.1817932128906 -6.758422841812717e-06 C 116.7195739746094 -6.758422841812717e-06 122.0195159912109 5.299933433532715 122.0195159912109 11.83771324157715 C 122.0195159912109 18.3754940032959 116.7195739746094 23.67543411254883 110.1817932128906 23.67543411254883 Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "j",
    transform: "translate(180.532 85.247) rotate(-37)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M11.838,0h98.344a11.838,11.838,0,1,1,0,23.675H11.838A11.838,11.838,0,0,1,11.838,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M 110.1817932128906 19.67543411254883 C 114.503532409668 19.67543411254883 118.0195159912109 16.15945243835449 118.0195159912109 11.83771324157715 C 118.0195159912109 7.515973091125488 114.503532409668 3.999993324279785 110.1817932128906 3.999993324279785 L 11.83771419525146 3.999993324279785 C 7.515974044799805 3.999993324279785 3.999994277954102 7.515973091125488 3.999994277954102 11.83771324157715 C 3.999994277954102 16.15945243835449 7.515974044799805 19.67543411254883 11.83771419525146 19.67543411254883 L 110.1817932128906 19.67543411254883 M 110.1817932128906 23.67543411254883 L 11.83771419525146 23.67543411254883 C 5.299934387207031 23.67543411254883 -5.819091711600777e-06 18.3754940032959 -5.819091711600777e-06 11.83771324157715 C -5.819091711600777e-06 5.299933433532715 5.299934387207031 -6.758422841812717e-06 11.83771419525146 -6.758422841812717e-06 L 110.1817932128906 -6.758422841812717e-06 C 116.7195739746094 -6.758422841812717e-06 122.0195159912109 5.299933433532715 122.0195159912109 11.83771324157715 C 122.0195159912109 18.3754940032959 116.7195739746094 23.67543411254883 110.1817932128906 23.67543411254883 Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoMain);
export default __webpack_public_path__ + "static/media/logo-main.477c77980a992b861dc90beba0f3e947.svg";
export { ForwardRef as ReactComponent };